module.exports = __webpack_public_path__ + "43fc9bbe7d0b26fce7001e28a6df2544.pdf";